var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialNetworkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4950",
    "data-name": "Group 4950",
    transform: "translate(1536 18625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4943",
    "data-name": "Group 4943",
    transform: "translate(-1827 -18774)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(291 149)",
    fill: "#18beb3",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_world_1819963",
    transform: "translate(-1534.3 -18623.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5665",
    "data-name": "Path 5665",
    d: "M20.3,10.3a10,10,0,1,0,10,10A10.012,10.012,0,0,0,20.3,10.3Zm7.192,5.274H25.505A9.562,9.562,0,0,0,24,12.56,8.758,8.758,0,0,1,27.492,15.574ZM24.821,20.3a13.8,13.8,0,0,1-.411,3.425H16.122a13.412,13.412,0,0,1-.411-3.425,13.8,13.8,0,0,1,.411-3.425h8.356A18.727,18.727,0,0,1,24.821,20.3ZM20.3,28.862c-1.507,0-2.945-1.507-3.767-3.767H24C23.245,27.355,21.807,28.862,20.3,28.862ZM16.533,15.574c.822-2.26,2.192-3.767,3.767-3.767s2.945,1.507,3.767,3.767ZM16.6,12.56a11.269,11.269,0,0,0-1.507,3.014H13.108A8.758,8.758,0,0,1,16.6,12.56Zm-4.247,4.384h2.329a17.57,17.57,0,0,0-.342,3.425,18.134,18.134,0,0,0,.342,3.425H12.355a8.057,8.057,0,0,1-.685-3.425A9.249,9.249,0,0,1,12.355,16.944Zm.753,8.151h1.986A9.562,9.562,0,0,0,16.6,28.108,8.758,8.758,0,0,1,13.108,25.095ZM24,28.108a11.269,11.269,0,0,0,1.507-3.014h1.986A8.758,8.758,0,0,1,24,28.108Zm4.247-4.384h-2.4A17.57,17.57,0,0,0,26.19,20.3a18.134,18.134,0,0,0-.342-3.425h2.329a8.057,8.057,0,0,1,.685,3.425A9.231,9.231,0,0,1,28.245,23.725Z",
    transform: "translate(0 0)",
    fill: "#18beb3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialNetworkIcon);
export default __webpack_public_path__ + "static/media/social-network-icon.a14f4a8db0c5ba8a86d78f11b5716547.svg";
export { ForwardRef as ReactComponent };